module.exports = __webpack_public_path__ + "img/road3.b3811039.jpg";